import React from "react";

export default function SQL_CASE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_CASE</h1>
      <p>This is the SQL_CASE component generated from the SQL JSON.</p>
    </div>
  );
}
